import {
  Link,
  Redirect,
  Route,
  useHistory,
  useLocation,
} from "react-router-dom";
import PropTypes from "prop-types";
import { useKeycloak } from "@react-keycloak/web";
import logo from "../../assets/images/logo.png";
import logOut from "../../assets/images/log_out.svg";
import { useMutation } from "react-query";

import { createClassPlan } from "../../api/classPlan";
import { useSelector } from "react-redux";
import { getClassDetailsById } from "../../utils/reactQueries";
import { IoMdMenu } from "react-icons/io";

const InternalTeacherDashboard = ({ component: Component, ...rest }) => {
  const { keycloak } = useKeycloak();
  const history = useHistory();
  const isClassPlanUpdate = useSelector(
    (state) => state.classPlan.isClassPlanUpdate
  );
  let redirectRoute = null;
  const { pathname } = useLocation();
  const slicePath = pathname.split("/");
  const classCreatedURl = slicePath[1];

  /** below lines used to check pathname  have class-plan path or not*/
  const pathArray = pathname.split("/");
  const isClassPlanPath = pathArray.some((item) =>
    pathname.includes("class-plan")
  );
  const classID = localStorage.getItem("classId");

  if (keycloak && keycloak.authenticated) {
    const isTeacher = keycloak.realmAccess.roles.includes("teacher");
    if (!isTeacher) {
      redirectRoute = "/student/upcoming-class";
    }
  } else {
    redirectRoute = "/login";
  }

  return (
    <Route
      {...rest}
      render={(matchProps) =>
        redirectRoute ? (
          <Redirect push to={redirectRoute} />
        ) : (
          <div className="flex flex-col min-h-screen bg-[#18114e]">


            
            <div className="flex-1 p-[19px] overflow-auto">
              <Component {...matchProps} />
            </div>
          </div>
        )
      }
    />
  );
};

export default InternalTeacherDashboard;

InternalTeacherDashboard.propTypes = {
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
};